/**
 * Old rate-card URLs (TMMPDM-0089): the customer card list and pages replace to the one Rate cards
 * list and card page (the query string kept), and the retired wholesale card editor's URLs replace
 * to the list.
 */
import { Navigate, useLocation, useParams } from 'react-router-dom';

export function LegacyCustomerCardRedirect() {
  const { id } = useParams();
  const { search } = useLocation();
  const to = id === undefined ? '/rate-cards' : `/rate-cards/${encodeURIComponent(id)}`;
  return <Navigate to={`${to}${search}`} replace />;
}

export function LegacyWholesaleCardRedirect() {
  return <Navigate to="/rate-cards" replace />;
}
